export default __webpack_public_path__ + "static/media/recommendHuman.2f370af6.png";